import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

function ListVersionsHeader({ result, interrupted }: ToolUseProps) {
  const done = !!result && !result.isError;
  return (
    <ToolStatus
      icon="history"
      text={done ? "Listed published versions" : "Listing published versions…"}
      pending={!done && !interrupted}
    />
  );
}

function ListVersionsBody({ result }: ToolUseProps) {
  if (!result) return null;
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(result.output, null, 2)}
      </pre>
    </Text>
  );
}

export const listVersions: ChatTool = {
  name: "listVersions",
  Header: ListVersionsHeader,
  Body: ListVersionsBody,
};
